/** Live broadcast / announcements controls (push-to-talk). */
export const broadcast = {
  // Fleet-/location-wide live broadcast presenter (web control page, CB-050).
  panel: {
    title: "Live broadcast",
    subtitle: "Talk live to many players at once over their announcement channel.",
    mode: {
      fleet: "Whole fleet",
      locations: "Locations",
      devices: "Devices",
    },
    pickLocations: "Choose one or more locations to broadcast to.",
    pickDevices: "Choose one or more devices to broadcast to.",
    noLocations: "No locations yet. Add locations on the Sites page first.",
    noDevices: "No devices you can operate yet.",
    selectionSummary: {
      one: "{count} selected",
      other: "{count} selected",
    },
    holdToTalk: "Hold to talk ({seconds}s)",
    keepHolding: "Keep holding… {seconds}",
    release: "Release to stop",
    starting: "Going live…",
    ending: "Ending…",
    liveBadge: "Live",
    liveTo: "Live to {connected} of {total} devices",
    reconnecting: "Reconnecting to control channel…",
    peer: {
      connecting: "Connecting",
      connected: "Live",
      failed: "Failed",
      closed: "Closed",
    },
    offlineWarning: {
      one: "{count} targeted device is offline and won't hear this broadcast.",
      other: "{count} targeted devices are offline and won't hear this broadcast.",
    },
    turnWarning:
      "Secure relay (TURN) is unavailable. Players behind restrictive networks may not connect.",
    endedByServer: "The broadcast was ended.",
    error: {
      permissionDenied: "Microphone access was denied.",
      entitlement:
        "Live broadcast needs an active subscription. Check the Billing page.",
      noEligibleDevices:
        "No active devices with Live Broadcast enabled match the selected targets.",
      allOffline: "None of the targeted devices are online right now.",
      unknown: "Could not start the broadcast.",
    },
  },
} as const;
